/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 15.04.2016.
 */

import Cookies from 'js-cookie';
import moment from 'moment';

import _get from 'lodash/get';
import _isArray from 'lodash/isArray';
import _isObject from 'lodash/isObject';
import _map from 'lodash/map';
import _keys from 'lodash/keys';
import _pick from 'lodash/pick';
import _each from 'lodash/each';
import _flatten from 'lodash/flatten';
import _find from 'lodash/find';
import _matchesProperty from 'lodash/matchesProperty';

export const urlRegExp = /^(https?):\/\/(?:(?:(?:[\w\.\-\+!$&'\(\)*\+,;=]|%[0-9a-f]{2})+:)*(?:[\w\.\-\+%!$&'\(\)*\+,;=]|%[0-9a-f]{2})+@)?(?:(?:[a-z0-9\-\.]|%[0-9a-f]{2})+|(?:\[(?:[0-9a-f]{0,4}:)*(?:[0-9a-f]{0,4})\]))(?::[0-9]+)?(?:[\/|\?](?:[\w#!:\.\?\+=&@!$'~*,;\/\(\)\[\]\-]|%[0-9a-f]{2})*)?$/;
export const validAppUrls = /\b(showcase|epg|settings|favorites|purchases|search|notifications|rdvr)\b/;
export const EPG_ROW_HEIGHT = 69;
export const EPG_EVENT_MIN_DURATION = 600;

/**
 * TODO: Desc to all UTILS
 * @returns {boolean}
 */

export const RDVR_STATES = {
  PENDING: 0,   // начальное состояние
  SCHEDULED: 1, // устройство подтвердило запрос на запись
  RECORDING: 2, // устройство ведет запись
  FINISHED: 3,  // устройство успешно закончило запись
  FAILED: 4,    // запрос на запись завершился ошибкой
  CANCELLED: 5  // запрос на запись отменен
};

export const MOMENT_CALENDAR_NPVR = {
  sameDay: '[Today]',
  nextDay: '[Tomorrow]',
  nextWeek: 'dddd',
  lastDay: '[Yesterday]',
  lastWeek: '[Last] dddd',
  sameElse: 'DD/MM/YYYY'
};

export const StubFunc = (from) => {
  console.warn('Stub fun call from: ', from || 'unknown');
};

export const ReduxPromiseMiddlewareTypes = (type) => {
  return [
    type + '_PENDING',
    type + '_FULFILLED',
    type + '_REJECTED'];
};

export const ParseResource = (resource = '') => {
  var parsed = {};
  var args = resource.split('?');

  if (args.length < 2) return parsed;

  args = args[1].split('&');

  if (args.length < 1) return parsed;

  args.forEach(function (arg) {
    parsed[arg.split('=')[0]] = (parseInt(arg.split('=')[1], 10)) ? parseInt(arg.split('=')[1], 10) : arg.split('=')[1];
  });

  return parsed;
};

export const PendingState = (type) => type + '_PENDING';
export const SuccessState = (type) => type + '_FULFILLED';
export const ErrorState = (type) => type + '_REJECTED';

export const prepareChannels = (channels, scheduleCollection) => {
  return channels.map(function (channel) {
    //TODO: is_catchup 2.0
    channel.epg = _get(_find(scheduleCollection, {id: channel.id}), 'schedule', []);

    return channel;
  });
};

export const prepareSchedule = (schedule, reqOptions) => {

  if (schedule.length) {

    //Add first program to Schedule
    if (schedule[0].start > reqOptions.start) {

      schedule.unshift({
        id: 'fake_' + reqOptions.channel_id + '_' + schedule[0].start + '_' + Math.abs(schedule[0].start - reqOptions.start),
        start: reqOptions.start,
        duration: Math.abs(schedule[0].start - reqOptions.start),
        title: 'no_data',
        program: {
          title: 'no_data'
        },
        is_fake: true
      });
    }

    schedule = schedule.map(function (event, index) {
      event.record = _find(lh.common.records, {epg_schedule_item_id: event.id}) || null;
      event.notification = _find(lh.common.notifications, (notification) => {

          return _get(notification, 'program.id') === _get(event, 'program.id') && _get(notification, 'start') === _get(event, 'start');
        }) || null;

      event.type = 'epg_event';

      if (schedule[index + 1]) {

        if (event.start + event.duration - schedule[index + 1].start < -300) {
          return [event, {
            id: 'fake_' + reqOptions.channel_id + '_' + event.start + '_' + event.duration,
            start: event.start + event.duration,
            duration: Math.abs(event.start + event.duration - schedule[index + 1].start),
            title: 'no_data',
            program: {
              title: 'no_data'
            },
            is_fake: true
          }];
        }
      }

      return event;
    });

    //Add last program to Schedule
    if (schedule[schedule.length - 1].start + schedule[schedule.length - 1].duration < reqOptions.end) {

      schedule.push({
        id: 'fake_' + reqOptions.channel_id + '_' + (schedule[schedule.length - 1].start + schedule[schedule.length - 1].duration) + '_' + Math.abs(reqOptions.end - schedule[schedule.length - 1].start + schedule[schedule.length - 1].duration),
        start: schedule[schedule.length - 1].start + schedule[schedule.length - 1].duration,
        duration: Math.abs(reqOptions.end - schedule[schedule.length - 1].start + schedule[schedule.length - 1].duration),
        title: 'no_data',
        program: {
          title: 'no_data'
        },
        is_fake: true
      });
    }

    return _flatten(schedule);

  } else {

    return [{
      id: 'fake_empty_row_' + reqOptions.channel_id + '_' + reqOptions.start + '_' + (reqOptions.end - reqOptions.start),
      start: reqOptions.start,
      duration: reqOptions.end - reqOptions.start,
      title: 'no_data',
      program: {
        title: 'no_data'
      },
      is_fake: true
    }];
  }
};

export const getScroll = () => {
  if (window.pageYOffset != undefined) {
    return [pageXOffset, pageYOffset];
  }
  else {
    var sx, sy, d = document, r = d.documentElement, b = d.body;
    sx = r.scrollLeft || b.scrollLeft || 0;
    sy = r.scrollTop || b.scrollTop || 0;
    return [sx, sy];
  }
};

export const isEndOfPage = () => {

  var D = document;

  var totalHeight = Math.max(
    D.body.scrollHeight, D.documentElement.scrollHeight,
    D.body.offsetHeight, D.documentElement.offsetHeight,
    D.body.clientHeight, D.documentElement.clientHeight
  );

  var currentScroll;
  if (D.documentElement.scrollTop) {
    currentScroll = D.documentElement.scrollTop;
  }
  else {
    currentScroll = D.body.scrollTop;
  }

  var visibleHeight = D.documentElement.clientHeight;

  return visibleHeight + currentScroll >= totalHeight;
};

export const DocumentDimensions = () => {

  var D = document;

  var totalHeight = Math.max(
    D.body.scrollHeight, D.documentElement.scrollHeight,
    D.body.offsetHeight, D.documentElement.offsetHeight,
    D.body.clientHeight, D.documentElement.clientHeight
  );

  var totalWidth = Math.max(
    D.body.scrollWidth, D.documentElement.scrollWidth,
    D.body.offsetWidth, D.documentElement.offsetWidth,
    D.body.clientWidth, D.documentElement.clientWidth
  );

  return {
    width: totalWidth,
    height: totalHeight
  };
};

export const WindowDimensions = () => {

  return {
    width: window.innerWidth,
    height: window.innerHeight
  };
};

export const positiveOrZero = (number) => {
  return (number < 0 ? 0 : number) || 0;
};

export const positiveOrZeroAndLessThan = (number, border) => {

  return (number < 0 ? 0 : number) && (number > border ? border : number) || 0;
};

/**
 * This method return day in human usual meaning (from 6am to 6am next day)
 */
export const toHumanDay = (day = moment()) => {
  let _6_am = day.clone().hour(6).startOf('hour');

  if (day.isBefore(_6_am)) {

    return {
      start: day.clone().add(-1, 'days').hour(6).startOf('hour').unix(),
      end: _6_am.unix()
    }
  } else {

    return {
      start: _6_am.unix(),
      end: day.clone().add(1, 'days').hour(6).startOf('hour').unix()
    }
  }
};

/**
 * This method return day in human usual meaning (from 6am to 6am next day)
 */
export const toHumanTime = (totalSec = 0) => {
  var hours = parseInt(totalSec / 3600) % 24;
  var minutes = parseInt(totalSec / 60) % 60;
  var seconds = totalSec % 60;

  return (hours < 10 ? "0" + hours : hours) + ":" + (minutes < 10 ? "0" + minutes : minutes) + ":" + (seconds < 10 ? "0" + seconds : seconds);
};

export const Sign = (x) => {
  return x && x / Math.abs(x);
};

export const S4 = () => {

  return Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1);
};

export const Guid = () => {

  return S4() + S4() + '-' + S4() + '-' + S4() + '-' +
    S4() + '-' + S4() + S4() + S4();
};

export const deepPick = (object, json) => {
  if (_isArray(json) && _isArray(object)) {
    return _map(object, function (item) {
      if (_isObject(item)) {
        return deepPick(item, json[0]);
      } else {
        return item;
      }
    });
  }
  object = _pick(object, _keys(json));
  _each(_keys(json), function (key) {
    if (_isObject(json[key] && object[key])) {
      object[key] = deepPick(object[key], json[key]);
    }
  });
  return object;
};

export const HasHash = new RegExp('^#\/?|\/$', 'g');

export const GetLocalStorageValue = (key, defaultValue) => {
  let value = defaultValue;

  try {
    value = JSON.parse(_get(localStorage, key));

  } catch (e) {
    console.warn('Can\'t get localStorage: ', key.toString());

    return value;
  }

  return value;
};

export const SetLocalStorageValue = (key, value) => {

  try {
    localStorage[key] = JSON.stringify(value);

  } catch (e) {

    console.warn('Error set localStorage: ', key.toString(), value.toString());
  }
};

export const GetLocaleForMoment = () => {
  let locale = Cookies.getJSON('cur_locale') || Config.def_locale;

  return locale;
};


export const SetLocaleForMoment = (locale) => {
  let parsedLocale = locale.split('_')[0];


  if (parsedLocale === 'jp') {

    moment.locale('ja');
  } else {

    moment.locale(parsedLocale);
  }

  return locale;
};


export const GetUser = () => {
  let user = Cookies.getJSON('v2_' + Config.operator_ext_id) || {
      user: 'guest',
      token: null
    };

  return user;
};

export const parseAppUrl = (appUrl, categories) => {
  let href = '/';
  let params = [];

  let parse = appUrl.split('://');

  if (parse[0] === 'ui' && parse.length > 1) {
    parse = parse[1].split('?');

    if (validAppUrls.test(parse[0])) {
      href += parse[0];

      if (parse[1]) {
        parse = parse[1].split('&');

        href += '/';

        window.availableCategories = categories;

        parse.forEach((item) => {
          let parse = item.split('=');

          if (parse[0] === 'categories') {
            let category = _find(availableCategories, _matchesProperty('extid', parse[1])) ||
              _find(availableCategories, _matchesProperty('id', parseInt(parse[1], 10)));

            if (category) {
              params.push(parse[0][0].toUpperCase() + category.id);
            }
          }

          if (parse[0] === 'views') {
            let views = parse[1].split(',');
            let href = '';

            if (views.length) href += parse[0][0].toUpperCase();

            if (views.indexOf('live') !== -1) {
              href += 'L'
            }

            if (views.indexOf('vod') !== -1) {
              href += 'V'
            }

            params.push(href);
          }

          if (parse[0] === 'sort') {
            let href = '';

            if (parse[1] === 'lcn') href += 'SL';

            params.push(href);
          }
        });

        href += params.join('+');
      }
    }

  }

  return href;
};

export function FadeOutEl(el) {

  return new Promise((resolve, reject) => {

    (function fade() {
      if ((el.style.opacity -= .1) < 0) {
        el.style.display = "none";
        resolve(el);
      } else {
        requestAnimationFrame(fade);
      }
    })();
  });
}

export function FadeInEl(el, display) {

  return new Promise((resolve, reject) => {
    el.style.opacity = 0;
    el.style.display = display || "block";

    (function fade() {
      var val = parseFloat(el.style.opacity);
      if (!((val += .1) > 1)) {
        el.style.opacity = val;
        requestAnimationFrame(fade);
      } else {
        resolve(el);
      }
    })();
  });
}

export function PrintMonitoring(obj) {
  let string = '';

  for (let key in obj) {
    string += '_' + key + ' ' + JSON.stringify(obj[key]) + '; ';

  }

  return string;
}



// WEBPACK FOOTER //
// ./src/utils.js